import React, { createContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; 
import userAPI from './Api'; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Clear cookies
  const clearCookies = () => {
    document.cookie.split(';').forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  };

  // Handle login
  const login = (token) => {
    localStorage.setItem('token', token);
    try {
      const decodedToken = jwtDecode(token);
      setUser({ 
        username: decodedToken.username, 
        id: decodedToken.sub, 
        isAdmin: decodedToken.isAdmin 
      });
      navigate(decodedToken.isAdmin ? '/adminpanel' : '/dashboard');
    } catch (error) {
      console.error("Token decoding failed:", error);
      logout();
    }
  };

  // Handle logout
  const logout = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        await userAPI.logoutUser(token);
        console.log('Logged out from server');
      } catch (error) {
        console.error('Logout failed:', error.response?.data || error.message);
      }
    }
    localStorage.removeItem('token');
    clearCookies(); // Clear any cookies
    setUser(null);
    navigate('/');
  }, [navigate]);

  // Load user on page refresh
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp && decodedToken.exp > currentTime) {
          setUser({ 
            username: decodedToken.username, 
            id: decodedToken.sub, 
            isAdmin: decodedToken.isAdmin 
          });
        } else {
          console.warn("Token expired");
          logout();
        }
      } catch (error) {
        console.error("Invalid token:", error);
        logout();
      }
    }
  }, [logout]);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;

// Let me know if you want me to refine anything else! 🚀
